import './App.css';
import React, { createRef, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client'
import './global.scss';
import './sidebar.scss';
import axios from 'axios';
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
  useOutlet,
} from 'react-router-dom'
import { CSSTransition, SwitchTransition } from 'react-transition-group'

import { NotificationContainer } from 'react-notifications';
import Home from './pages/home/Home';
import { Footer } from './components/global/footer/Footer';
import { Topbar } from './components/global/top/Topbar';
import { Header } from './components/global/header/Header';
import { Attorneys } from './pages/attorneys/Attorneys';
import { PracticeAreas } from './pages/practice-areas/PracticeAreas';
import Default from './pages/default';
import Blog from './pages/blog';
import { SingleBlog } from './pages/blog/single';
import { ContactUs } from './pages/contact-us/ContactUs';
import { NotFound } from './pages/404/404';
import { CaseResults } from './pages/case-results/CaseResults';
import { SidebarPage } from './pages/sidebar-page';
import Category from './pages/blog/category';

axios.defaults.baseURL = 'https://mullenpersonalinjurylawyers.com/';

const routes = [
  {path: '/es/', name: 'Home', element: <Home />, nodeRef: createRef()},
  {path: '/es/case-results/', name: 'CaseResults', element: <CaseResults />, nodeRef: createRef()},
  {path: '/es/not-found/', name: 'OurFirm', element: <NotFound />, nodeRef: createRef()},
  {path: '/es/contact-us/', name: 'ContactUs', element: <ContactUs />, nodeRef: createRef()},
  {path: '/es/practice-areas/', name: 'PracticeAreas', element: <PracticeAreas />, nodeRef: createRef()},
  {path: '/es/practice-areas/:slug/', name: 'SinglePracticeArea', element: <SidebarPage parent_slug={'practice-areas'} />, nodeRef: createRef()},
  {path: '/es/:slug/', name: 'SinglePage', element: <Default />, nodeRef: createRef()},
  // {path: '/attorneys/', name: 'Attorneys', element: <Attorneys />, nodeRef: createRef()},
  {path: '/es/legal-blog/', name: 'Articles', element: <Blog />, nodeRef: createRef()},
  {path: '/es/legal-blog/:slug/', name: 'Article', element: <SingleBlog />, nodeRef: createRef()},
  {path: '/es/legal-blog/category/:slug/', name: 'Article', element: <Category />, nodeRef: createRef()},
  {path: '/es/our-lawyers/', name: 'Our Lawyers', element: <Attorneys />, nodeRef: createRef()},

  {path: '/', name: 'Home', element: <Home />, nodeRef: createRef()},
  {path: '/case-results/', name: 'CaseResults', element: <CaseResults />, nodeRef: createRef()},
  {path: '/not-found/', name: 'OurFirm', element: <NotFound />, nodeRef: createRef()},
  {path: '/contact-us/', name: 'ContactUs', element: <ContactUs />, nodeRef: createRef()},
  {path: '/practice-areas/', name: 'PracticeAreas', element: <PracticeAreas />, nodeRef: createRef()},
  {path: '/practice-areas/:slug/', name: 'SinglePracticeArea', element: <SidebarPage parent_slug={'practice-areas'} />, nodeRef: createRef()},
  {path: '/:slug/', name: 'SinglePage', element: <Default />, nodeRef: createRef()},
  // {path: '/attorneys/', name: 'Attorneys', element: <Attorneys />, nodeRef: createRef()},
  {path: '/legal-blog/', name: 'Articles', element: <Blog />, nodeRef: createRef()},
  {path: '/legal-blog/:slug/', name: 'Article', element: <SingleBlog />, nodeRef: createRef()},
  {path: '/legal-blog/category/:slug/', name: 'Article', element: <Category />, nodeRef: createRef()},
  {path: '/our-lawyers/', name: 'Our Lawyers', element: <Attorneys />, nodeRef: createRef()}
]


const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: routes.map((route) => ({
      index: route.path === '/',
      path: route.path === '/' ? undefined : route.path,
      element: route.element,
    })),
  },
]);


function App() {
  const location = useLocation()
  const currentOutlet = useOutlet()
  const [menus, setMenus] = useState(null);
  const [footerMenu, setFooterMenu] = useState([]);
  const [globalOptions, setGlobalOptions] = useState(null);


  useEffect(() => {
    window.scrollTo(0, 0);
    return (() => {})
  }, [location]);

  const fetchMenus = async () => {
    try {
      const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_menu_content");

      var hmstr =  data?.data?.header_menu ?? '';
      if (window.location.href?.includes("/es/") || window.location.href?.endsWith("/es")) {
        //hmstr = hmstr.replaceAll('href="https://mullenpersonalinjurylawyers.com/','href="https://mullenpersonalinjurylawyers.com/es/')
      } else {
        
      }      
      setMenus(hmstr);
      setFooterMenu(data?.data?.footer_menu ?? '');
    } catch (e) {
      setMenus('');
      setFooterMenu('');
    }
  };

  const fetchGlobalOptions = async () => {
    try {
      const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_global_site_options");
      console.log(data)
      setGlobalOptions(data);
    } catch (e) {
      setGlobalOptions(null);
    }
  }
  
  useEffect(() => {
    fetchMenus();
    fetchGlobalOptions();
  }, [])


  const { nodeRef } =
    routes.find((route) => route.path === location.pathname) ?? {}
  
  return (
    <>
      <div id="page-wrapper">
        <NotificationContainer />
        {/* <Topbar globalOptions={globalOptions} /> */}
        <Header menu={menus} globalOptions={globalOptions}/>
        <div className='page-main-wrapper'>
          <SwitchTransition>            
            <CSSTransition
              key={location.pathname}
              nodeRef={nodeRef}
              timeout={300}
              classNames="page"
              unmountOnExit
            >

              {(state) => (
                <>
                  <div ref={nodeRef} className="page">
                    {currentOutlet}
                  </div>
                </>
              )}
            </CSSTransition>
          </SwitchTransition>
        </div>
            <Footer globalOptions={globalOptions} footerMenu={footerMenu} />
      </div>
    </>
  )
}
const container = document.getElementById('root')
const root = createRoot(container)
root.render(<RouterProvider router={router} />)
